export default __webpack_public_path__ + "static/media/image26.7a4efbbb.png";